import React from "react";

import normalLogo from "../../assets/images/logos/edu-logo.png";

const Preloader = () => {
  return (
    <div id="react__preloader">
      <div id="react__circle_loader"></div>
      <div className="react__loader_logo">
        <img src={normalLogo} alt="Preload" />
      </div>
    </div>
  );
};

export default Preloader;
